import { ObservableObject } from "@legendapp/state";
import { createContext } from "react";
import { ViewSettings } from "./types";
import { viewSettings$ } from "./state";

export const ViewSettingsContext =
  createContext<ObservableObject<ViewSettings>>(viewSettings$);

export function ViewSettingsProvider({ children }: React.PropsWithChildren) {
  return (
    <ViewSettingsContext.Provider value={viewSettings$}>
      {children}
    </ViewSettingsContext.Provider>
  );
}
